import { render, staticRenderFns } from "./modalProcessNotFound.vue?vue&type=template&id=60e7078a"
import script from "./modalProcessNotFound.vue?vue&type=script&lang=js"
export * from "./modalProcessNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports